import PropTypes from "prop-types";

export const BaseRedirectLinkContainer = ({ children, id }) => (
  <span className="text-md line-height-[20px] text-default" {...(id && { id })}>
    {children}
  </span>
);

BaseRedirectLinkContainer.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
};
